import { TextField } from '@mui/material';

export interface ReadOnlyTextFieldProps {
    label: string;
    value: string | undefined;
}

const READ_ONLY_TEXT_FIELD_SX = {
    backgroundColor: 'background.paper',
    borderRadius: '4px',
} as const;

export function ReadOnlyTextField({ label, value }: Readonly<ReadOnlyTextFieldProps>) {
    return (
        <TextField
            sx={READ_ONLY_TEXT_FIELD_SX}
            size="small"
            label={label}
            variant="filled"
            defaultValue={value}
            disabled
        />
    );
}
